// Kept dependency-free (no import of @/services/access.service, which pulls in api.service.ts
// and is `vi.mock`ed by several specs) -- src/pinia/access.ts needs this and is itself part of
// the chain src/test.init.ts loads eagerly, before per-test `vi.mock` calls can intercept
// anything a static import there would pull in. See accessOverview.ts's own comment.
//
// holdings[].max[].subject is "MODULE:<subjectKey>" (e.g. "MODULE:ACCESS", "MODULE:3D-MODEL") --
// a different shape than the bare subjectKey RoleCatalogEntry/RoleGrant use elsewhere. Strips the
// prefix so callers can compare against/display via the bare key (functionLabel, 'ACCESS',
// 'PROPERTY_ACCESS', ...).
export function bareSubjectKey(subject: string): string {
  const idx = subject.indexOf(':')
  return idx >= 0 ? subject.slice(idx + 1) : subject
}
